import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type MgsaEntityFragment = { id: string, entityType: Types.MgsaEntityTypeEnum, entityId: string, mindsetCount?: number | null, skillCount?: number | null, goalsSummary?: string | null, resolvedGoals?: Array<{ id: string, name: string }> | null, activities?: Array<{ description?: string | null, activityType: Types.MgsaActivityTypeEnum, activityEntityId?: string | null }> | null, mindsets?: Array<{ id: string, name: string, description?: string | null, attachedToEntitiesCount?: { contentsCount: number, okrsCount: number, tasksCount: number } | null }> | null, skillGroupConfigs?: Array<{ skillGroupName: string, skillConfig: Array<{ expectedScore: number, reviewerScore: number, score?: number | null, skillId: string, skills?: { id: string, name: string, attachedToEntitiesCount?: { contentsCount: number, okrsCount: number, tasksCount: number } | null } | null }> }> | null };


export type MgsaEntityFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const MgsaEntityFragmentDoc = /*#__PURE__*/ gql`
    fragment MgsaEntityFragment on MgsaType {
  id
  entityType
  entityId
  mindsetCount
  skillCount
  goalsSummary
  resolvedGoals {
    id
    name
  }
  activities {
    description
    activityType
    activityEntityId
  }
  mindsets {
    id
    name
    description
    attachedToEntitiesCount {
      contentsCount
      okrsCount
      tasksCount
    }
  }
  skillGroupConfigs {
    skillGroupName
    skillConfig {
      expectedScore
      reviewerScore
      score
      skillId
      skills {
        id
        name
        attachedToEntitiesCount {
          contentsCount
          okrsCount
          tasksCount
        }
      }
    }
  }
}
    `;